var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 20.337h-1.416c-.435-1.457-1.771-2.529-3.366-2.529-1.597 0-2.933 1.072-3.367 2.529h-7.702c-.434-1.457-1.77-2.529-3.366-2.529S5.85 18.88 5.416 20.337H4v-4.244h24v4.244zm-4.782 2.529c-.46 0-.866-.209-1.148-.53a1.52 1.52 0 01-.382-1c0-.383.148-.73.383-1a1.52 1.52 0 011.147-.527c.458 0 .866.206 1.146.527.235.27.382.617.382 1 0 .385-.147.732-.382 1-.28.322-.687.53-1.146.53zm-15.582-.53a1.514 1.514 0 01-.382-1c0-.383.147-.73.383-1 .28-.32.687-.527 1.146-.527.458 0 .866.206 1.147.527.234.27.382.617.382 1 0 .385-.148.732-.382 1a1.521 1.521 0 01-1.147.53c-.46 0-.866-.209-1.147-.53zM6.225 9.674h1.66v3.445h2V9.672h3.073v3.446h2V9.672h2.993v3.446h2V9.672h3.126v3.446h2V9.672H28v4.421H4.473l1.752-4.42zm22.775-2H5.545c-.41 0-.778.25-.93.63L2.07 14.726a.99.99 0 00-.062.33c-.001.014-.008.026-.008.039v6.243a1 1 0 001 1h2.416c.435 1.457 1.77 2.529 3.367 2.529 1.596 0 2.933-1.072 3.366-2.53h7.702c.434 1.458 1.77 2.53 3.367 2.53 1.595 0 2.932-1.072 3.366-2.53H29a1 1 0 001-1V8.674a1 1 0 00-1-1z",
    fill: props.color
  })));
}

export default SvgIconBus;